// extracted by mini-css-extract-plugin
module.exports = {"imgHeader":"component-module--img-header--2e_2T","container":"component-module--container--3LJY_","img":"component-module--img--3PF3u"};